'use client';

import { FC, Fragment } from 'react';
import { PopularProductCarouselProps } from './types';
import {
  clickTrackingURL,
  RecommendedProductItem,
  RecommendedProducts,
} from '@/types/algonomy';
import TopSellingDTO from '@/dto/topSellingDTO';
import TopSellingCard from '@/components/Cards/TopSellingCard';
import styles from './PopularProductCarousels.module.css';
import EmblaCarousel from '../EmblaCarousel';
import clsx from 'clsx';

const PopularProductEmblaCarousel: FC<PopularProductCarouselProps> = ({ placement }) => {
  const { strategyMessage, recommendedProducts } = placement;

  const handleSelectCard = (
    clickUrl: clickTrackingURL,
    linkUrl: string,
  ) => {
    fetch(clickUrl || '')
      .catch((error) => {
        console.log('can not send tracking url data to algonomy from algonomy carousel', error, clickUrl);
      })
      .finally(() => {
        window.location.href = linkUrl;
      });
  };

  const handleRightClickCard = (clickUrl: clickTrackingURL) => {
    fetch(clickUrl || '').catch((error) => {
      console.log('can not send tracking url data to algonomy from algonomy carousel', error, clickUrl);
    });
  };

  const renderRecommendedProductCarousel = (
    recommendedProductItem: RecommendedProductItem,
    idx: number,
  ) => {
    const topSellingProduct = new TopSellingDTO(recommendedProductItem);

    return (
      <Fragment key={idx}>
        <TopSellingCard
          searchItem={topSellingProduct.getProduct}
          idx={idx}
          priorityIndex={-1}
          onClick={handleSelectCard}
          onContextMenu={handleRightClickCard}
          className={styles.miniCartCarouselCard}
        />
        <div key={idx} className={styles.carouselPadding}></div>
      </Fragment>
    );
  };

  return (
    <div className={clsx(`${styles.categoryTopSellings} topSellingCarousel`)}>
      <p className={`${styles.categoryCarouselTitle} topSellingCarouselTitle`}>{strategyMessage}</p>
      <EmblaCarousel<RecommendedProducts>
        options={{
          slidesToScroll: 2,
          breakpoints: {
            '(min-width: 768px)': { slidesToScroll: 3 },
            '(min-width: 960px)': { slidesToScroll: 4 },
          },
        }}
        slides={recommendedProducts.map((product, idx) => renderRecommendedProductCarousel(product, idx))}
      />
    </div>
  );
};

export default PopularProductEmblaCarousel;
